import { RoutePermissions } from '../constants/RoutePermissions';
import { DefaultRoutePermissions } from '../constants/DefaultRoutePermissions';
import { IPermissionsProps } from '../helpers/PermissionsHelper';
import { SHOW_CERTIFIED_FILE_MODAL } from '../main/store/EventData/types';

export enum ActiveProductsType {
    certified_file = 'certified_file',
}

export interface Route {
    BASE: string;
    LINK?: string;
    PERMISSIONS: (RoutePermissions | DefaultRoutePermissions)[];
    actionType?: string;
    exactPath?: boolean;
    canActivate: Function;
    routeFallback?: string;
}

export const SUBSCRIPTION_BILLING_URL = '#/subscription/billing';
export const SETTINGS_UPGRADE_URL = '#/settings/upgrade';
export const ACADEMY_ONBOARDING_URL = '/academy/onboarding';
export const HOME_URL = '#/request-list/all/all';
export const HOME_WIDGETS = '#/academy';
export const SIGNACADEMY = '#/academy/lessons';
export const RESELLER = '#/partners';

export const MENU_LINKS = {
    REQUEST_LIST: {
        BASE: '#/request-list',
        PROGRESS: {
            BASE: '#/request-list/progress',
            LINK: '#/request-list/progress/all',
        },
        COMPLETED: {
            BASE: '#/request-list/completed',
            LINK: '#/request-list/completed/all',
        },
        ALL: {
            BASE: '#/request-list/all',
            LINK: '#/request-list/all/all',
        },
        ARCHIVED: {
            BASE: '#/request-list/archived',
            LINK: '#/request-list/archived/all',
        },
    },
    FILES: {
        BASE: '#/files',
    },
    TEMPLATES: {
        BASE: '#/templates',
        NEW_REQUEST: '#/templates/new-request',
    },
    TEMPLATE_LIST: {
        BASE: '#/template-list',
    },
    CERTIFICATES: {
        BASE: '#/certificates',
    },
    TEAMS: {
        BASE: '#/teams',
        MEMBERS: {
            BASE: '#/teams/members',
            LINK: '#/teams/members',
        },
        GROUPS: {
            BASE: '#/teams/groups',
            LINK: '#/teams/groups',
        },
    },
    CONTACT_LIST: {
        BASE: '#/contact-list',
    },
    ACCOUNT_DEV: {
        BASE: '#/account-dev',
        API_REQUEST: {
            BASE: '#/account-dev/api-request',
            LINK: '#/account-dev/api-request',
        },
        WEB_HOOK: {
            BASE: '#/account-dev/web-hook',
            LINK: '#/account-dev/web-hook',
        },
    },
    SETTINGS: {
        BASE: '#/settings',
        BILLING: {
            BASE: '#/settings/billing',
            LINK: '#/settings/billing',
        },
        ACCOUNT: {
            BASE: '#/settings/account',
            LINK: '#/settings/account',
        },
        INTEGRATIONS: {
            BASE: '#/settings/integrations',
            LINK: '#/settings/integrations',
        },
        SECURITY: {
            BASE: '#/settings/security',
            LINK: '#/settings/security',
        },
        BRANDING: {
            BASE: '#/settings/branding',
            LINK: '#/settings/branding',
        },
    },
    ACCOUNT_SETTINGS: {
        BASE: '#/account-settings',
        BILLING: {
            BASE: '#/account-settings/billing',
            LINK: '#/account-settings/billing',
        },
        ACCOUNT: {
            BASE: '#/account-settings/account',
            LINK: '#/account-settings/account',
        },
        INTEGRATIONS: {
            BASE: '#/account-settings/integrations',
            LINK: '#/account-settings/integrations',
        },
        SECURITY: {
            BASE: '#/account-settings/security',
            LINK: '#/account-settings/security',
        },
        BRANDING: {
            BASE: '#/account-settings/branding',
            LINK: '#/account-settings/branding',
        },
    },
    PAYMENT: {
        BASE: '#/billing/payment',
    },
    UPGRADE: {
        BASE: SETTINGS_UPGRADE_URL,
    },
    SUBSCRIPTION: {
        BASE: SUBSCRIPTION_BILLING_URL,
    },
    RESELLER: {
        BASE: '#/partners',
    },
};
export const APP_ROUTES_WITH_PERMISSIONS: Route[] = [
    {
        ...MENU_LINKS.ACCOUNT_DEV,
        PERMISSIONS: [RoutePermissions.HasApi],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.CERTIFICATES,
        PERMISSIONS: [RoutePermissions.CertificateSection],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.FILES,
        PERMISSIONS: [DefaultRoutePermissions.Files],
        actionType: SHOW_CERTIFIED_FILE_MODAL,
        canActivate: (permissionsProps: IPermissionsProps) => {
            return !permissionsProps.activeProducts?.some(
                (activeProduct: any) => activeProduct.type === ActiveProductsType.certified_file
            );
        },
    },
    {
        ...MENU_LINKS.TEMPLATE_LIST,
        PERMISSIONS: [RoutePermissions.ShowNewTemplates, DefaultRoutePermissions.Templates],
        canActivate: () => {},
        routeFallback: MENU_LINKS.TEMPLATES.BASE,
    },
    {
        ...MENU_LINKS.TEMPLATES,
        PERMISSIONS: [RoutePermissions.ShowLegacyTemplates, DefaultRoutePermissions.Templates],
        exactPath: true,
        canActivate: () => {},
        routeFallback: MENU_LINKS.TEMPLATE_LIST.BASE,
    },
    {
        ...MENU_LINKS.CONTACT_LIST,
        PERMISSIONS: [DefaultRoutePermissions.Contacts],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.REQUEST_LIST,
        PERMISSIONS: [DefaultRoutePermissions.RequestList],
        canActivate: () => {}
    },
    {
        ...MENU_LINKS.ACCOUNT_SETTINGS,
        PERMISSIONS: [RoutePermissions.ShowNewSettings, DefaultRoutePermissions.Settings],
        exactPath: true,
        canActivate: () => {},
        routeFallback: MENU_LINKS.SETTINGS.BASE
    },
    {
        ...MENU_LINKS.SETTINGS,
        PERMISSIONS: [RoutePermissions.ShowLegacySettings, DefaultRoutePermissions.Settings],
        exactPath: true,
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.SETTINGS.BILLING,
        PERMISSIONS: [RoutePermissions.IsAdmin],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.SETTINGS.ACCOUNT,
        PERMISSIONS: [DefaultRoutePermissions.Account],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.SETTINGS.INTEGRATIONS,
        PERMISSIONS: [DefaultRoutePermissions.Integrations],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.SETTINGS.BRANDING,
        PERMISSIONS: [RoutePermissions.IsAdmin],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.SETTINGS.SECURITY,
        PERMISSIONS: [RoutePermissions.IsAdmin],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.PAYMENT,
        PERMISSIONS: [RoutePermissions.IsAdmin],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.UPGRADE,
        PERMISSIONS: [RoutePermissions.IsAdmin],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.SUBSCRIPTION,
        PERMISSIONS: [RoutePermissions.IsAdmin],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.TEAMS,
        PERMISSIONS: [DefaultRoutePermissions.Teams],
        canActivate: () => {},
    },
    {
        ...MENU_LINKS.RESELLER,
        PERMISSIONS: [RoutePermissions.Reseller],
        canActivate: () => {},
    },
];
